"use strict";

var _collections = require("./collections");

module.exports = function entitledToViewHomePage(editions) {
  var validEditions = _collections.DEBTWIRE_CORE_EDITIONS.concat(_collections.ABS_EDITIONS).concat(_collections.EDITIONS_MAP.MUNICIPALS);

  return editions.some(function (edition) {
    return validEditions.includes(edition);
  });
};